import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AdminLayout } from '../../../components/layout/AdminLayout';
import EventForm from '../../../components/admin/events/EventForm';
import { useEvents } from '../../../hooks/useEvents';
import { useToast } from '../../../hooks/useToast';

const CreateEvent: React.FC = () => {
  const navigate = useNavigate();
  const { addEvent } = useEvents();
  const { showToast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const handleSubmit = async (eventData: any) => {
    try {
      setIsSubmitting(true);
      await addEvent(eventData);
      showToast('Événement créé avec succès', 'success');
      navigate('/events/admin');
    } catch (error: any) {
      showToast(error.message || 'Erreur lors de la création de l\'événement', 'error');
      setIsSubmitting(false);
    }
  };
  
  return (
    <AdminLayout>
      <div className="px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-4">
          <Link
            to="/events/admin"
            className="text-yellow-400 hover:text-yellow-300 flex items-center text-sm"
          >
            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Retour aux événements
          </Link>
        </div>
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-100">Créer un nouvel événement</h1>
          <p className="mt-1 text-sm text-gray-300">
            Remplissez le formulaire ci-dessous pour créer un nouvel événement.
          </p>
        </div>
        <div className="bg-black/90 shadow rounded-lg p-6 border border-white/10">
          <EventForm onSubmit={handleSubmit} isSubmitting={isSubmitting} />
        </div>
      </div>
    </AdminLayout>
  );
};

export default CreateEvent;
